import { useStepper } from './StepperManager';

export const useStepperActions = () => {
    const { actions } = useStepper();

    return actions;
};
